var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-element-loading',{attrs:{"active":_vm.loading,"is-full-screen":true,"spinner":"spinner","color":"#007bff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }